import image1Src from '../../src/assets/right-section-images/image1.jpg';
import image2Src from '../../src/assets/right-section-images/image2.jpg';
import image3Src from '../../src/assets/right-section-images/image3.jpg';
import image4Src from '../../src/assets/right-section-images/image4.jpg';
import image5Src from '../../src/assets/right-section-images/image5.jpg';
import image6Src from '../../src/assets/right-section-images/image6.jpg';
import image7Src from '../../src/assets/right-section-images/image7.png';

const rightSectionImages = [
    image1Src,
    image2Src,
    image3Src,
    image4Src,
    image5Src,
    image6Src,
    image7Src
];

export const getRandomRightSectionImageSrc = () => {
    const randomIndex = Math.floor(Math.random() * rightSectionImages.length);

    return rightSectionImages[randomIndex];
};
